import { Box, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react-lite";

import style from "./Explore_2_2.module.css";
import MultiChoiceBtnGroup from "../../components/button_group/MultiChoiceBtnGroup2";
import PageButton from "../../components/PageButton";
import RectangleGroup from "../../components/explore/Explore_2_2_img";

function Explore_2_2() {
  return (
    <Box className={style.box}>
      <Grid xs={12} container justifyContent="center" alignItems="center">
        <Grid item xs={12} md={6} className={style.questionbox}>
          <div>
            <Typography variant="h4">創新就是門好生意嗎？</Typography>
          </div>
          <div className={style.line}></div>
          <div className={style.TitleBox}>
            <Typography variant="h7" className={style.Title}>
              即使了解創業不容易，但仍想創業的動機是？
            </Typography>
            <Typography variant="h7" className={style.SubTitle}>
              &nbsp;(請選擇)
            </Typography>
          </div>
          <div className={style.ChoiceBtn}>
            <MultiChoiceBtnGroup
              flexible
              btnList={[
                "發現市場需求",
                "受其他創業家啟發",
                "完成人生目標",
                "已開發出好的產品",
                "公司內部創業spin-off競爭者",
                "發現新興產業競爭者少",
              ]}
            />
          </div>
          {/* <div>
            已選擇:{" "}
            {selectedObject2.map((text) => (
              <span>{text}, </span>
            ))}
          </div> */}
          <div className={style.Discription}>
            <Typography variant="h7">
              下圖是根據〈2019台灣新創生態圈大調查〉發現新創認為營收不如預期或未開始獲利的原因。
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} md={5} margin={4}>
          <RectangleGroup className={style.Rectangle} />
        </Grid>
      </Grid>
      <div className={style.pageBtn}>
        <PageButton passPath={"/explore-4"} nextPath={"/explore-2-3"} />
      </div>
    </Box>
  );
}

export default observer(Explore_2_2);
